<template>
  <header class="page-header">
    <div class="left">
      <button
        class="btn"
        id="menu-toggle"
        @click="toggleSidebar"
      >
        <i class="fal fa-bars"></i>
      </button>
    </div>
    <div :class="showSearch ? 'middle has-search' : 'middle'">

      <div v-if="!showSearch" class="page-title">
          <slot name="title" /><h1>{{ title }}</h1>
      </div>

      <div v-if="showSearch" class="global-search">
        <multiselect
        class="carbon-search"
        v-model="search"
        placeholder="Search Carbon"
        track-by="heading"
        @search-change="asyncFind"
        @select="onSelect"
        @close="onClose"
        :clearOnSelect="true"
        :internal-search="false"
        :loading="isLoading"
        :show-labels="false"
        :options="options"
        >

            <template slot="singleLabel" slot-scope="props">
                <div></div>
            </template>

            <template slot="option" slot-scope="props">
              <div class="row no-gutters">
                <div class="col-auto d-flex align-items-center">
                    <img v-if="props.option.img != ''" class="option__image" :src="props.option.img" alt="" />
                    <i v-else class="option__icon far" :class="props.option.icon"></i>
                </div>
                <div class="col d-flex align-items-center">
                    <div>
                        <p>{{ props.option.heading }}</p>
                        <p class="small">{{ props.option.subheading }}</p>
                    </div>
                </div>
              </div><!-- /.row -->
            </template>

        </multiselect>
      </div>

      <div class="actions">
        <slot name="actions" />
      </div>

    </div>
    <div class="right">
      <ul class="header-nav justify-content-end">
        <li>
          <button
            type="button"
            class="btn btn-sidesheet-show navbar-user-link d-xl-none"
          >
            <i class="fal fa-columns"></i>
          </button>
        </li>
        <li>
          <button
            type="button"
            class="btn"
          >
            <i class="fal fa-fw fa-question-circle"></i>
          </button>
        </li>
        <li>
          <div class="dropdown">
            <button
              type="button"
              class="btn btn-account"
              id="dropdownMenuButton"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <img :src="avatarSrc" :alt="authorized.name" />
              <i class="far fa-chevron-down"></i>
            </button>
            <div
              class="dropdown-menu dropdown-menu-right dropdown-menu-account"
              aria-labelledby="dropdownMenuButton"
            >
              <router-link :to="{ name: 'users.overview', params: { 'id': authorized.id }}" class="dropdown-item"><i class="far fa-fw fa-user-circle"></i> My Account</router-link>
              <router-link tag="a" class="dropdown-item" :to="{ name: 'auth.logout' }"><i class="far fa-fw fa-sign-out"></i> Logout</router-link>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </header>
</template>

<script>
import { mapState } from 'vuex'
import { http } from 'utils'

export default {
  data () {
    return {
      options: [],
      search: "",
      isLoading: false
    }
  },

  props: {
    title: String
  },

  computed: {
    ...mapState('user', ['authorized']),

    showSearch() {
      return (!this.title || !(this.title.length > 0)) && !this.$slots['title']
    },

    avatarSrc () {
      return `${process.env.VUE_APP_API_URL}/user/${this.authorized.id}/avatar`
    }
  },

  methods: {
    toggleSidebar () {
      const wrapper = document.getElementById('wrapper')

      wrapper.classList.toggle('toggled')
      wrapper.classList.add('transitioning')

      setTimeout(() => {
        wrapper.classList.remove('transitioning')
        this.$bus.$emit('menu-toggled')
      }, 300)

    },

    asyncFind (query) {

      if (query.length > 2) {
        this.isLoading = true
        http.get(`/search?search=${query}`).then(response => {
          this.options = response.data
          this.isLoading = false
        })
      }
    },
    onClose () {
      //Clear any current search term
      this.$nextTick(() => {
        this.search = ""
        this.options = []
      })
    },
    onSelect (option) {
      switch(option.type) {
        case 'Client':
          this.$router.push({ name: 'clients.details', params: { client_id: option.id } })
          break
        case 'Project':
          this.$router.push({ name: 'projects.show.details', params: { project_id: option.id } })
          break
        case 'Opportunity':
          this.$router.push({ name: 'opportunities.overview', params: { opportunity_id: option.id } })
          break
        case 'Contact':
          this.$router.push({ name: 'clients.contacts', params: { client_id: option.client_id } })
          break
        case 'UserStory':
          this.$router.push({ name: 'projects.stage3.scrum.detail', params: { project_id: option.project_id, stage_id: 3, user_story_doc_id: option.user_story_doc_id, sprint_id: option.sprint_id, story_id: option.id } })
          break
      }
    }
  }
}
</script>
